import React, { useContext } from 'react'
import Image from 'next/image'

import normalizeCta from '@models/CTA'

import SectionThemeContext from '@contexts/SectionTheme'

import { Button } from '@/atoms'
import { Heading, Paragraph } from '@/atoms/Typography'
import { SpacerBase } from '@/atoms/Grid'

import normalizeImage from '@models/Image'

import * as S from './styles'

const BaseCard = ({ title, paragraph, cta, image }) => {
  const normalizedImage = normalizeImage(image)

  const colorScheme = useContext(SectionThemeContext)

  const normalizedCta = normalizeCta(cta)

  return (
    <S.BaseCard colorScheme={colorScheme}>
      {image ? (
        <S.BaseCardImage>
          <Image
            src={normalizedImage.url}
            alt={normalizedImage.alt}
            fill
            sizes='(max-width: 768px) 50vw, (max-width: 1200px) 50vw, 33vw'
          />
        </S.BaseCardImage>
      ) : null}
      <S.BaseCardText>
        {title ? (
          <Heading
            as='div'
            typo='displayMD'
            bold
          >
            {title}
          </Heading>
        ) : null}
        {paragraph ? (
          <>
            <SpacerBase xs={2} />
            <Paragraph typo='paragraph1'>{paragraph}</Paragraph>
          </>
        ) : null}
        {cta ? (
          <>
            <SpacerBase xs={2} />
            <Button
              {...normalizedCta}
              tertiary
            />
          </>
        ) : null}
      </S.BaseCardText>
    </S.BaseCard>
  )
}

export default BaseCard
